import { ajaxSetup, ajax, getJSON } from 'jquery';
import { IOptions } from '../options';
import { getConfig, notify } from '../components/Utils';
import { FormsFiltersServer } from '../types/RequestMain';

export interface IHandler {
  (...params: any[]): void;
}

export interface IErrorHandler {
  (status: number, error: string): void;
}

export interface IProgressHandler {
  (progress: number): void;
}

export interface IHandlers {
  before?: IHandler;
  success?: IHandler;
  anyway?: IHandler;
  error?: IErrorHandler;
  progress?: IProgressHandler;
}

export interface IFileOptions {
  id: string;
  maxSize: number;
  format: string;
  element: any;
}

interface RequestOptions {
  url: string;
  method: string;
  contentType?: string | boolean;
  xhr?: () => XMLHttpRequest;
  processData?: boolean;
  data?: any;
}

export interface RejectApplication {
  form_type: string;
  process_id: number;
  comment: string;
}

export function createApiClient(
  form_type: string = null,
  process_id: number = 0,
) {
  let formates = {
    PDF: ['PDF'],
    Image: ['JPG', 'PNG', 'JPEG'],
  };

  ajaxSetup({
    xhrFields: {
      withCredentials: true,
    },
  });

  let config = getConfig();

  if (form_type !== null) {
    config.form_type = form_type;
  }
  if (process_id !== null) {
    config.process_id = process_id;
  }
  // config.filesUrl = `${config.filesUrl}/${config.id}/${config.valuesId}`;

  // return new ApiClient(config, formates, false)
  return new ApiClient(config, formates, false);
}

const errorHandler = (_, response) => {
  const { errors } = JSON.parse(response);
  console.log('errors:', errors, ' response:', response);
  if (typeof errors !== 'undefined' && errors.length > 0) {
    if (errors[0].error.code === '400') {
      notify(errors[0].error.message);
      window.location.reload();
    }
  }
};

export class ApiClient {
  private lock: boolean;
  private options: IOptions;
  private setValueUrl: string;
  private urlApi: string;
  private userApi: string;
  private companiesApi: string;
  private projectsApi: string;
  private actionUrl: string;
  private filesUrl: string;

  constructor(
    options: IOptions,
    formats: {
      [format: string]: Array<string>;
    },
    lock: boolean,
  ) {
    this.options = options;
    this.setValueUrl =
      this.options.apiUrl +
      '/item/' +
      this.options.form_type +
      '/' +
      this.options.process_id +
      '/';
    this.actionUrl =
      this.options.apiUrl + '/action/' + this.options.process_id + '/';
    this.urlApi = this.options.apiUrl;
    this.userApi = this.options.apiUser;
    this.companiesApi = this.options.companyUrl;
    this.projectsApi = this.options.projectsUrl;
    this.filesUrl =
      this.options.filesUrl +
      '/' +
      this.options.form_type +
      '/' +
      this.options.process_id +
      '/';

    this.FileFormats = formats;

    this.lock = lock;
  }

  public readonly FileFormats: {
    [format: string]: Array<string>;
  };

  public isLocked() {
    return this.lock;
  }

  public getReportUrl(formId: string, valuesId: string) {
    return `${this.userApi}/report/${formId}/${valuesId}`;
  }

  public getAttachFileUrl(formId: string, valuesId: number, uid: string) {
    return `${this.options.apiUrl}/${formId}/${valuesId}/notify/${uid}/files`;
  }

  public createSession(formId: string, company: Object, handlers: IHandlers) {
    this.send(
      {
        url: `${this.urlApi}/${formId}`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(company),
      },
      handlers,
    );
  }

  public me(handlers: IHandlers) {
    getJSON(`${this.userApi}/me/`, handlers.success);
  }

  public getNotify(formId: string, values: number, handlers: IHandlers) {
    getJSON(`${this.urlApi}/notify/${formId}/${values}`, handlers.success);
  }

  public getHistory(request: number, handlers: IHandlers) {
    getJSON(`${this.urlApi}/item/${request}/status_history`, handlers.success);
  }

  public company(handlers: IHandlers) {
    getJSON(`${this.userApi}/company/`, handlers.success);
  }

  public getCompanyORN(inn: string, handlers: IHandlers) {
    getJSON(`${this.userApi}/company/orn/${inn}`, handlers.success).fail(
      handlers.error,
    );
  }

  public getTags(handlers: IHandlers) {
    getJSON(`${this.companiesApi}/tags`, handlers.success).fail(handlers.error);
  }

  public getCities(handlers: IHandlers) {
    getJSON(`${this.companiesApi}/cities`, handlers.success).fail(
      handlers.error,
    );
  }

  public redirect(url: string) {
    window.location.href = `${this.userApi}/auth?url=${encodeURIComponent(
      window.location.href,
    )}`;
  }

  public singout(url: string) {
    window.location.href = `${this.userApi}/singout?url=${encodeURIComponent(
      window.location.href,
    )}`;
  }

  public sendValues(handlers: IHandlers) {
    this.send(
      {
        url: this.actionUrl + '/send',
        method: 'POST',
      },
      handlers,
    );
  }

  public sendDocument(handlers: IHandlers, form?: any) {
    this.send(
      {
        url: this.setValueUrl + 'send',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(form || {}),
      },
      handlers,
    );
  }

  public sendRevoke(handlers: IHandlers, form?: any) {
    this.send(
      {
        url: this.setValueUrl + 'revoke',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(form || {}),
      },
      handlers,
    );
  }

  public sendAdditional(handlers: IHandlers) {
    this.send(
      {
        url: this.actionUrl + '/additional',
        method: 'POST',
      },
      handlers,
    );
  }

  public sendPDF(handlers: IHandlers) {
    this.send(
      {
        url: this.actionUrl + '/pdf',
        method: 'POST',
      },
      handlers,
    );
  }

  public cloneRequest(handlers: IHandlers) {
    this.send(
      {
        url: `${this.actionUrl}/clone`,
        method: 'POST',
      },
      handlers,
    );
  }

  public deleteValues(handlers: IHandlers) {
    this.send(
      {
        url: this.actionUrl + '/delete',
        method: 'DELETE',
      },
      handlers,
    );
  }

  public getFileUrl(
    controlId: string,
    fileName: string,
    timestamp?: number,
  ): string {
    if (timestamp !== undefined) fileName = timestamp + '/' + fileName;

    return encodeURI(
      `${this.options.filesUrl}/${this.options.form_type}/${this.options.process_id}/${controlId}/${fileName}`,
    );
  }

  public setValue(id: string, value: any, handlers: IHandlers = null) {
    handlers.error = errorHandler;

    this.send(
      {
        url: this.setValueUrl + id,
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({
          timestamp: Date.now(),
          value: value,
        }),
      },
      handlers,
    );
  }

  public setValueSync(id: string, value: any, handlers: IHandlers = null) {
    this.send(
      {
        url: this.setValueUrl + '/' + id,
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({
          timestamp: Date.now(),
          value,
        }),
      },
      handlers,
      false,
    );
  }

  public putValue(id: string, value: any, handlers: IHandlers = null): number {
    const timestamp = Date.now();

    this.send(
      {
        url: this.setValueUrl + '/' + id,
        method: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify({
          timestamp: timestamp,
          value: value,
        }),
      },
      handlers,
    );
    return timestamp;
  }

  public removeValue(
    id: string,
    timestamp: number,
    handlers: IHandlers = null,
  ) {
    handlers.error = errorHandler;
    this.send(
      {
        url: this.setValueUrl + id /* + "/?timestamp=" + timestamp, */,
        method: 'DELETE',
      },
      handlers,
    );
  }

  public removeReportPdf(
    formId: string,
    values: string,
    handlers: IHandlers = null,
  ) {
    this.send(
      {
        url: `${this.options.apiUrl}/${formId}/${values}/report`,
        method: 'DELETE',
      },
      handlers,
    );
  }

  public setBlobFileValue(
    options: IFileOptions,
    value: any,
    fileId: string,
    handlers: IHandlers,
  ): string {
    const file = options.element;
    if (file == undefined || file == null) return null;

    const data = new FormData();
    data.append('file', file);
    data.append('value', value);
    data.append('fileId', fileId);

    let success: IHandler = null;
    if (handlers != null && handlers.success != null) {
      success = handlers.success;
      handlers.success = function(res) {
        success(res);
      };
      handlers.error = errorHandler;
    }

    this.send(
      {
        xhr: function(): XMLHttpRequest {
          const xhr = new XMLHttpRequest();
          if (handlers != null && handlers.progress != null) {
            xhr.upload.addEventListener('progress', e => {
              handlers.progress((e.loaded / e.total) * 100);
            });
          }
          return xhr;
        },
        url: this.filesUrl + options.id + '/file',
        method: 'POST',
        contentType: false,
        data: data,
        processData: false,
      },
      handlers,
    );
  }

  public setFileValue(
    options: IFileOptions,
    value: any,
    fileId: string,
    handlers: IHandlers,
  ): string {
    const file = options.element.files[0];
    if (file == undefined || file == null) return null;

    const data = new FormData();
    data.append('file', file);
    data.append('value', value);
    data.append('fileId', fileId);

    let success: IHandler = null;
    if (handlers != null && handlers.success != null) {
      success = handlers.success;
      handlers.success = function(res) {
        success(res);
      };
      handlers.error = errorHandler;
    }

    this.send(
      {
        xhr: function(): XMLHttpRequest {
          const xhr = new XMLHttpRequest();
          if (handlers != null && handlers.progress != null) {
            xhr.upload.addEventListener('progress', e => {
              handlers.progress((e.loaded / e.total) * 100);
            });
          }
          return xhr;
        },
        url: this.filesUrl + options.id + '/file',
        method: 'POST',
        contentType: false,
        data: data,
        processData: false,
      },
      handlers,
    );
  }

  public deleteFileValue(
    id: string,
    fileName: string,
    value: any,
    fileId: string,
    handlers: IHandlers,
  ) {
    handlers.error = errorHandler;
    this.send(
      {
        url: encodeURI(this.filesUrl + id + '/' + fileId),
        method: 'DELETE',
      },
      handlers,
    );
  }

  public getFormByUid(id: string, values: number, handlers: IHandlers) {
    getJSON(`${this.urlApi}/${id}/${values}`, handlers.success).fail(
      handlers.error,
    );
  }

  public getAllValues(handlers: IHandlers) {
    getJSON(this.urlApi, handlers.success).fail(handlers.error);
  }

  /**
   *
   * @param page
   * @param pagesize
   * @param formKind используется для определения типа юзера:
   * Либо инвестор, либо компания, либо админ (с ролью и без указания form_kind), используется при выдаче определенного вида форм не через фильтры
   * @param filters имеет параметр filter_form_kind, используемый только для админа, чтобы фильтровать то что на странице с фильтруемым списком форм
   */

  public getForms(
    {
      page,
      pagesize,
      formKind,
      filters,
    }: {
      page: number;
      pagesize: number;
      formKind?: number;
      filters?: FormsFiltersServer;
    },
    handlers: IHandlers,
  ) {
    let requestUrl = `${this.urlApi}/`;

    if (!!page && !!pagesize) {
      requestUrl += `?page=${page}&page_size=${pagesize}`;
    }

    if (typeof formKind !== 'undefined') {
      requestUrl += `&form_kind=${formKind}`;
    }

    let formFiltersPartUrl = '';

    if (!!filters) {
      Object.entries(filters).forEach(([key, value]) => {
        formFiltersPartUrl += !!value ? `&${key}=${value}` : '';
      });
    }

    requestUrl += formFiltersPartUrl;

    getJSON(requestUrl, handlers.success).always(handlers.anyway);
  }

  public getSettings(handlers: IHandlers) {
    getJSON(`${this.urlApi}/settings`, handlers.success).always(
      handlers.anyway,
    );
  }

  // public openForm(valuesId: string, formId: string, handlers: IHandlers) {
  //     getJSON(`${this.urlApi}/values/${valuesId}/${formId}`, handlers.success)
  //         .fail(handlers.error);
  // }
  //

  public createForm(data: object, handlers: IHandlers) {
    this.send(
      {
        url: `${this.urlApi}/item/create/`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(data),
      },
      handlers,
    );
  }

  public rejectApplication(
    { form_type, process_id, comment }: RejectApplication,
    handlers: IHandlers,
  ) {
    this.send(
      {
        url: `${this.urlApi}/item/${form_type}/${process_id}/revoke`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ comment }),
      },
      handlers,
    );
  }

  public copyForm(form_type: string, process_id: number, handlers: IHandlers) {
    this.send(
      {
        url: `${this.urlApi}/item/clone/${form_type}/${process_id}`,
        method: 'POST',
      },
      handlers,
    );
  }

  public revokeForm(
    form_type: string,
    process_id: number,
    handlers: IHandlers,
  ) {
    this.send(
      {
        url: `${this.urlApi}/item/revoke/${form_type}/${process_id}`,
        method: 'POST',
      },
      handlers,
    );
  }

  public deleteForm(
    form_type: string,
    process_id: number,
    handlers: IHandlers,
  ) {
    this.send(
      {
        url: `${this.urlApi}/item/${form_type}/${process_id}`,
        method: 'DELETE',
      },
      handlers,
    );
  }

  public openForm(form_type: string, process_id: number, handlers: IHandlers) {
    getJSON(`${this.urlApi}/item/${form_type}/${process_id}`, handlers.success)
      .fail(handlers.error)
      .always(handlers.anyway);
  }

  public companyInfo(inn: string, handlers: IHandlers) {
    getJSON(`${this.userApi}/company/${inn}`, handlers.success).fail(
      handlers.error,
    );
  }

  public suggest(text: string, handlers: IHandlers) {
    this.send(
      {
        url: `${this.userApi}/suggest`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          query: text,
        }),
      },
      handlers,
    );
  }

  public getCompanies(handlers: IHandlers) {
    getJSON(`${this.companiesApi}/list/`, handlers.success)
      .fail(handlers.error)
      .always(handlers.anyway);
  }

  public getProjects(orn: string, handlers: IHandlers) {
    getJSON(`${this.projectsApi}/${orn}`, handlers.success)
      .fail(handlers.error)
      .always(handlers.anyway);
  }

  public getValue(controlId: string, handlers: IHandlers) {
    this.send(
      {
        url: this.setValueUrl + '/' + controlId,
        method: 'GET',
      },
      handlers,
    );
  }

  public isRemovePanelBlock(key: string, handlers: IHandlers) {
    this.send(
      {
        url: `${this.setValueUrl}/${key}/isremove`,
        method: 'GET',
      },
      handlers,
    );
  }

  public hasRemoveBlock(key: string, handlers: IHandlers) {
    this.send(
      {
        url: `${this.setValueUrl}/${key}/hasremove`,
        method: 'GET',
      },
      handlers,
    );
  }

  private send(
    options: RequestOptions,
    handlers: IHandlers,
    async: boolean = true,
  ) {
    let success: IHandler = null;
    let error: IErrorHandler = null;
    if (handlers) {
      success = handlers.success;
      error = handlers.error;
    }

    ajax({
      xhr: options.xhr,
      url: options.url,
      type: options.method,
      contentType: options.contentType,
      data: options.data,
      processData: options.processData,
      success: success,
      async,
      error: function(jqXHR: JQueryXHR) {
        if (error != null) error(jqXHR.status, jqXHR.responseText);
      },
    });
  }

  private static getFileExtension(fileName: string) {
    return fileName.substring(fileName.lastIndexOf('.') + 1).toUpperCase();
  }
}
